import { render } from "./indexCleanNetAction.vue?vue&type=template&id=38ee91ec&scoped=true&ts=true"
import script from "./indexCleanNetAction.vue?vue&type=script&lang=ts"
export * from "./indexCleanNetAction.vue?vue&type=script&lang=ts"

import "./indexCleanNetAction.vue?vue&type=style&index=0&id=38ee91ec&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ee91ec"]])

export default __exports__